import type { UploadedFileInfo, FailedFileInfo } from '../types';

/**
 * 批量上传图片请求参数
 */
export interface BatchUploadImagesRequest {
    /** 图片文件列表 */
    files: File[];
    /** 文件夹路径，用于组织文件存储结构 */
    folder_path?: string;
    /** 文件名前缀，用于标识文件用途 */
    file_prefix?: string;
    /** 是否生成唯一文件名 */
    generate_unique_name?: boolean;
}

/**
 * 批量上传图片响应
 */
export interface BatchUploadImagesResponse {
    /** 上传成功的文件列表 */
    uploaded_files: UploadedFileInfo[];
    /** 上传失败的文件列表 */
    failed_files: FailedFileInfo[];
    /** 总文件数 */
    total_count: number;
    /** 成功上传数 */
    success_count: number;
    /** 失败上传数 */
    failed_count: number;
}

export const BatchUploadImagesApi = Symbol.for('BatchUploadImagesApi');

/**
 * 批量上传图片 API 接口
 * @description 提供批量上传图片的 API 调用
 */
export interface BatchUploadImagesApi {
    /**
     * 批量上传图片
     * @param request 批量上传请求参数
     * @returns 批量上传响应
     */
    batchUploadImages(request: BatchUploadImagesRequest): Promise<BatchUploadImagesResponse>;
}
